/*
 * @Author: your name
 * @Date: 2019-12-30 11:25:04
 * @LastEditTime: 2023-05-29 15:02:47
 * @LastEditors: zzj
 * @Description: In User Settings Edit
 * @FilePath: \my-demo\src\pages\CompanyIntroduction\company-profile\CompanyProfile.js
 */

import '../../../global.js';
import React from 'react';
//import './index.css';
import './company-profile.less'

//引入prefeb模块
import Bottom from '../../../common-components/BottomBar'
import Head from '../../../common-components/TopBar/TopBar'
import Card from '../components/card/Card'

let profileVideo = global.config.url + '/NewGrand/media/newgrand20180913.da890242.mp4';


//第一个模块
//网页第一个模块
class FirstPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShow: false,//默认不选择
        }

    }
    playvideo(isture) {
        this.setState({
            isShow: isture,
        });
    }

    render() {
        const isShow = this.state.isShow;
        let myvideo;
        if (isShow === true) {
            myvideo =
                <div className="first-page-vedio-box">
                    <div className="first-page-vedio-bd" onClick={() => this.playvideo(false)}></div>
                    <div className="first-page-vedio-margin">
                        <div className="first-page-video-exit" onClick={() => this.playvideo(false)}>
                            ×
                        </div>
                    </div>
                    <div className="first-page first-page-bg"></div>
                    {/* <div className="first-page-vedio">
                        <video autoPlay="autoplay" loop="loop" >
                            <source src="movie.ogg" type="video/ogg" />
                            <source src={profileVideo} type="video/mp4" />
                            <source src="movie.webm" type="video/webm" />
                            <object data="movie.mp4" width="100%" height="100%">
                                <embed width="100%" height="100%" src="movie.swf" />
                            </object>
                        </video>
                    </div> */}
                </div>
        } else {
            myvideo = <div></div>
        }

        return (
            <div className="first-page first-page-bg"></div>
            // <div className="first-page">
            //     <video autoPlay="autoplay" loop="loop" >
            //         <source src="movie.ogg" type="video/ogg" />
            //         <source src={profileVideo} type="video/mp4" />
            //         <source src="movie.webm" type="video/webm" />
            //         <object data="movie.mp4" width="100%" height="100%">
            //             <embed width="100%" height="100%" src="movie.swf" />
            //         </object>
            //     </video>
            //     {/*视频播放 */}
            //     {myvideo}
            //     <div className="first-page-show">
            //         {/* 
            //         <div className="first-page-show-logo"></div>
            //         <div className="first-page-show-text">
                     
            //         </div>
            //         <div className="first-page-show-icon" onClick={() => this.playvideo(true)}></div>
            //     */}
            //     </div>
            // </div>
        );
    }
}

//网页第二个模块
class SecondPage extends React.Component {
    render() {
        return (
            <div className="second-page">
                <div className="second-page-title">
                杭州新中大科技股份有限公司简介
                </div>
                <div className="second-page-text">
                    <div className="second-page-intend">
                    杭州新中大科技股份有限公司（简称“新中大”）历经30余年发展，已成为工程建设行业领先的数字化综合服务商，致力于为工程投资、工程总承包、施工总承包、专业承包、工程监理、行业管理等工程建设产业链参与方提供整体数字化管理解决方案，基于自主研发的钱潮技术平台帮助工程企业实现业财一体化、企项一体化、商务成本一体化、数模一体化的先进管理。
                    </div>
                    <div className="second-page-intend">
                    目前，新中大累计已为数万家企事业单位提供数字化管理产品与服务，其中特级资质企业项目管理软件市场占有率高达34%。公司曾先后入选国家火炬计划软件产业基地骨干企业、国家规划布局内重点软件企业、工业互联网产业最具影响力企业、浙江省科技小巨人、信创领军企业、软件行业平台软件领军企业；公司研发能力获得全球软件领域最高级别“CMMI 5级认证”，相关产品先后荣获数字建造领域国产自主可控优秀技术平台、工信部工业软件优秀产品等荣誉。
                    </div>
                    <div className="second-page-intend">
                    新中大以“创新、中和、大成、创业、责任、精益”为企业价值观，以“解决问题、超越期待”为服务理念，以“让天下没有难管的项目”为使命，力争成为全球领先的工程管理数智化平台服务商！
                    </div>
                </div>
            </div>
        );
    }
}

//网页第三个模块
class ThirdPage extends React.Component {
    render() {
        return (
            <div className="third-page">
                <div className="third-page-col">
                    <div className="interval-col-156"></div>
                    <div>
                        <div className="interval-85" />
                        <Card img={global.config.url + "/newgrand/picture/img/%E5%85%AC%E5%8F%B8%E4%BB%8B%E7%BB%8D/%E5%85%AC%E5%8F%B8%E7%AE%80%E4%BB%8B/Photo-1.png"}
                            title={"项目管理"} text={"工程项目管理软件是以钱潮技术平台为支撑构建的企业级数字化管控系列软件产品。着力解决工程建设行业多组织层级、多专业板块、多业务模式、多管控模式、多项目关联方、多系统集成的复杂业务场景带来的数字化痛点。针对客户的不同生产经营规模，提供以i8i工程投资管理软件、i8e工程总承包管理软件、i8施工总承包管理软件、i8c专业承包工程项目管理软件、P8工程项目管理软件、MC项目多方协同管理平台、mi8工程项目管理云平台为代表的不同类型的数字化产品，满足客户的数字化管控需求。"} />
                        <div className="interval-50" />
                        <Card img={global.config.url + "/newgrand/picture/img/%E5%85%AC%E5%8F%B8%E4%BB%8B%E7%BB%8D/%E5%85%AC%E5%8F%B8%E7%AE%80%E4%BB%8B/Photo-4.png"}
                            title={"智能建造"} text={"智能建造产品分为面向政府主管部门的城市级监管服务平台D6G和面向工程建设企业的企业级智能建造管理平台D6C，两大平台均以钱潮技术平台作为底层技术构建。D6G是以地区智能建造建设和评价标准为基础，采用“云大物智移”等技术，满足主管部门的工地可视化监管和在线执法需求的同时，提供面向项目各参建单位的各类场景应用及数据服务。D6C平台立足企业级，从“项目作业层、企业管理层、产业协作层”三层管理出发，采用“AIoT+BIM+GIS”等技术，实现多项目部现场“人、机、料、法、环、测”六要素的组合监管，同时核心关注“物联融合、数实融合、企项融合、产业融合”四大融合应用，最终实现集团远程监控指挥，项目现场节能提效的管理目标。"} />
                    </div>
                    <div className="interval-col-50"></div>
                    <div>
                        <div className="interval-85" />
                        <Card img={global.config.url + "/newgrand/picture/img/%E5%85%AC%E5%8F%B8%E4%BB%8B%E7%BB%8D/%E5%85%AC%E5%8F%B8%E7%AE%80%E4%BB%8B/Photo-3.png"}
                            title={"财税管理"} text={"在财税管理信息化领域积聚二十多年经验的新中大，拥有财务管理、资金管理、税务管理、费控管理、全面预算、财税共享中心等一系列软件产品和解决方案，帮助企业实现财税共享服务和业财税一体化管理。"} />
                        <div className="interval-50" />
                        <Card img={"/img/companyProfile_pic04.jpg"}
                            title={"管理咨询"} text={"工程企业咨询服务是公司根据现代管理与信息化的理论，结合工程建设企业管理软件和行业服务多年实践经验，总结形成的为企业管理提升与数字化转型所需要的全面咨询、培训服务和技术支持方案，满足企业从战略展望到执行实务中的组织、流程、绩效和IT等优化需求。"} />
                    </div>
                </div>
            </div>
        );
    }
}
//网页主模块
class CompanyProfile extends React.Component {
    render() {
        return (
            <div>
                <Head />
                <div className="company-profile">
                    <FirstPage />
                    <SecondPage />
                    <ThirdPage />
                </div>
                <Bottom />
            </div>
        );
    }
}

export default CompanyProfile;